import { render, staticRenderFns } from "./App.vue?vue&type=template&id=1bf08541&"
import script from "./App.vue?vue&type=script&lang=js&"
export * from "./App.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QLayout,QHeader,QToolbar,QToolbarTitle,QBtn,QTooltip,QPageContainer} from 'quasar'
component.options.components = Object.assign({QLayout,QHeader,QToolbar,QToolbarTitle,QBtn,QTooltip,QPageContainer}, component.options.components || {})
